import React, { Ref, useRef, useState } from 'react';
import * as Body from './Style'

type Props = {
    setText: any,
    placeholder?: string,
    disabled?: boolean,
    maxLenght?: number,
    code?: number,
    secret?: boolean,
    error?: boolean,
    ref?: Ref<any>
    align?: string,
    paddingRight?: number
}

const CodeInput: React.FC<Props> = ({
    setText, placeholder, disabled, maxLenght, code, secret, error, ref, align, paddingRight
}) => {

    const [digito1, setDigito1] = useState('')
    const [digito2, setDigito2] = useState('')
    const [digito3, setDigito3] = useState('')
    const [digito4, setDigito4] = useState('')
    const [digito5, setDigito5] = useState('')
    const [digito6, setDigito6] = useState('')

    const number1 = useRef<any>()
    const number2 = useRef<any>()
    const number3 = useRef<any>()
    const number4 = useRef<any>()
    const number5 = useRef<any>()
    const number6 = useRef<any>()

    const refs    = [number1, number2, number3, number4, number5, number6]
    const setters = [setDigito1, setDigito2, setDigito3, setDigito4, setDigito5, setDigito6]

    const buildCode = (vals: string[]) => vals.join('')

    const handlePaste = (e: React.ClipboardEvent) => {
        e.preventDefault()
        const digits = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6).split('')
        digits.forEach((d, i) => {
            setters[i](d)
            refs[i].current!.value = d
        })
        for (let i = digits.length; i < 6; i++) {
            setters[i]('')
            refs[i].current!.value = ''
        }
        const vals = Array(6).fill('').map((_, i) => digits[i] ?? '')
        setText(buildCode(vals))
        refs[Math.min(digits.length, 5)].current!.focus()
    }

    const field = (text: string, idx: number) => {
        const digit = text.slice(-1) // keep only last char if browser fires multiple
        setters[idx](digit)
        const vals = [digito1, digito2, digito3, digito4, digito5, digito6]
        vals[idx] = digit
        setText(buildCode(vals))
        if (digit.length > 0 && idx < 5) refs[idx + 1].current!.focus()
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, idx: number) => {
        if (e.key === 'Backspace' && e.currentTarget.value === '' && idx > 0) {
            setters[idx - 1]('')
            refs[idx - 1].current!.value = ''
            refs[idx - 1].current!.focus()
            const vals = [digito1, digito2, digito3, digito4, digito5, digito6]
            vals[idx - 1] = ''
            setText(buildCode(vals))
        }
    }

    return (
        <Body.DigitsContent onPaste={handlePaste}>
            {refs.map((ref, i) => (
                <Body.CodeInput
                    key={i}
                    autoComplete='one-time-code'
                    type='tel'
                    ref={ref}
                    maxLength={1}
                    onChange={e => field(e.target.value, i)}
                    onKeyDown={e => handleKeyDown(e, i)}
                    onFocus={e => e.target.select()}
                />
            ))}
        </Body.DigitsContent>
    )
}

export default CodeInput;
